var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcelIconFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3H17.0804C17.6146 2.99999 18.0604 2.99998 18.4247 3.02974C18.8046 3.06078 19.1612 3.12789 19.4985 3.29973C20.0159 3.56338 20.4366 3.98408 20.7003 4.50153C20.8721 4.83879 20.9392 5.19545 20.9703 5.57533C21 5.93956 21 6.3854 21 6.91955V9H10.5V3Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3H6.91957C6.38543 2.99999 5.93956 2.99998 5.57533 3.02974C5.19545 3.06078 4.83879 3.12789 4.50153 3.29973C3.98408 3.56339 3.56339 3.98408 3.29973 4.50153C3.12789 4.83879 3.06078 5.19545 3.02974 5.57533C2.99998 5.93956 2.99999 6.3854 3 6.91954V9H9V3Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.5V17.0804C2.99999 17.6146 2.99998 18.0604 3.02974 18.4247C3.06078 18.8046 3.12789 19.1612 3.29973 19.4985C3.56338 20.0159 3.98408 20.4366 4.50153 20.7003C4.83879 20.8721 5.19545 20.9392 5.57533 20.9703C5.93956 21 6.3854 21 6.91955 21H9V10.5H3Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21H17.0805C17.6146 21 18.0604 21 18.4247 20.9703C18.8046 20.9392 19.1612 20.8721 19.4985 20.7003C20.0159 20.4366 20.4366 20.0159 20.7003 19.4985C20.8721 19.1612 20.9392 18.8046 20.9703 18.4247C21 18.0604 21 17.6146 21 17.0805V10.5H10.5V21Z",
    fill: "#171717",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIconFill);
export default __webpack_public_path__ + "static/media/excel-icon-fill.a92297c8538c623caa68bca8a15a8bea.svg";
export { ForwardRef as ReactComponent };